import { useTranslation } from 'react-i18next'

import { DetailsModalRow } from '@pages/IntroducingBroker/components/DetailsModalRow'

import { BaseModalType } from '@context/ModalsContext'

import { Button } from '@ui/components/Button'
import { EditIcon } from '@ui/icons/Edit.icon'

import { SubIBAccount, SubIbAccountStatus } from '@model/MultiTierDto'

import { Box } from '@shared/components/Box'
import { PaginatedDetailsModal } from '@shared/modals/PaginatedDetails.modal'

interface SubIBAccountDetailsModalProps {
  accounts: SubIBAccount[]
  initialIndex: number
  onEdit: (data: SubIBAccount) => void
}

export const SubIBAccountDetailsModal: BaseModalType<SubIBAccountDetailsModalProps> = ({
  accounts,
  initialIndex,
  onEdit,
}) => {
  const { t } = useTranslation()

  return (
    <PaginatedDetailsModal
      items={accounts}
      initialIndex={initialIndex}
      title={(account) => account.account.name}
    >
      {(account) => (
        <>
          <DetailsModalRow
            label={t('IB.MultiTier.Sub-IB Accounts')}
            config={{ variant: 'text', label: account.account.name }}
          />
          <DetailsModalRow
            label={t('IB.Name')}
            config={{ variant: 'text', label: account.clientName }}
          />
          <DetailsModalRow
            label={t('IB.MultiTier.IB Commission')}
            config={{ variant: 'text', label: String(account.ibCommission) }}
          />
          <DetailsModalRow
            label={t('IB.MultiTier.Plan')}
            config={{ variant: 'text', label: account.commissionPlanGroup.name }}
          />
          <DetailsModalRow
            label={t('IB.Volume')}
            config={{ variant: 'text', label: String(account.volume) }}
          />
          {account.status.id !== SubIbAccountStatus.Inactive && (
            <Box pt='x8' fullWidth>
              <Button.Secondary fullWidth iconLeft={EditIcon} onClick={() => onEdit(account)}>
                {t('Edit')}
              </Button.Secondary>
            </Box>
          )}
        </>
      )}
    </PaginatedDetailsModal>
  )
}
